import React, { useState } from "react";
import MUIDataTable from "mui-datatables";
import ModalModificarObjetivo from "./ModalModificarReferente";
import DialogoEliminarReferente from "./DialogoEliminarReferente";

const TablaGlosario = ({ datosTabla, data2 }) => {
  const [itemClicked, setItemClicked] = useState(undefined);

  const columns = [
    {
      name: "nombre",
      label: "Nombre",
      options: {
        filter: false,
        display: true,
      },
    },
    {
      name: "color",
      label: "Color",
      options: {
        filter: false,
        display: true,
      },
    },

    {
      name: "id",
      label: " ",
      options: {
        filter: false,
        display: true,
        sort: false,
        viewColumns: false,
        customBodyRenderLite: (value, tableMeta, updateValue) => (
          <DialogoEliminarReferente id={data2[value][3]} />
        ),
      },
    },
  ];

  const options = {
    expandableRowsOnClick: true,
    filterType: "dropdown",
    responsive: "standard",
    download: false,
    tableBodyHeight: "estándar",
    tableBodyMaxHeight: "estándar",
    rowsPerPage: 10,
    print: false,
    viewColumns: true,
    filter: false,
    selectableRows: "none",
    onRowClick: (e, meta) => {
      handleOpenModal(meta.dataIndex);
    },

    textLabels: {
      body: {
        noMatch: "Registros no encontrados",
        toolTip: "Sort",
        columnHeaderTooltip: (column) => `Ordenar por ${column.label}`,
      },
      pagination: {
        next: "Siguiente",
        previous: "Anterior",
        rowsPerPage: "Registros por página:",
        displayRows: "de",
      },
      toolbar: {
        search: "Buscar",
        viewColumns: "Ver columnas",
        downloadCsv: "Descargar",
      },
      download: {},

      viewColumns: {
        title: "Mostrar columnas",
        titleAria: "Mostrar/Esconder columnas",
      },

      TableHead: {
        root: {
          color: "white",
          backgroundColor: "#007B7B",
        },
      },
    },
  };

  const handleOpenModal = (index) => {
    setItemClicked(datosTabla[index]);
  };

  const handleDeleteItemClicked = () => {
    setItemClicked(undefined);
  };

  return (
    <div>
      <MUIDataTable data={data2} columns={columns} options={options} />

      {itemClicked && (
        <ModalModificarObjetivo
          onHide={handleDeleteItemClicked}
          nombre={itemClicked[0]}
          id={itemClicked[3]}
          color={itemClicked[1]}
          colorLetra={itemClicked[2]}
        />
      )}
    </div>
  );
};

export default TablaGlosario;
